<template>
  <div class="error-modal">
    <div class="popup-modal_title">{{texts.error}}</div>
      <div>
        <div class="error-modal__message" v-if="isMessageHtml" v-html="message" />
        <p v-else>{{ message }}</p>
      </div>
    <button class="close-error-modal button" @click="onClick">{{ btnText }}</button>
  </div>
</template>

<script>
export default {
  name: 'errorModal',
  props: {
    message: String,
    isMessageHtml: {
      type: Boolean,
      default: false,
    },
    textEnable: {
      type: Boolean,
      default: true,
    },
    btnText: {
      type: String,
      default: 'OK',
    },
  },
  computed: {
    texts() {
      return {
        error: this.$t('Error'),
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.error-modal {
    display: flex;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    height: 100%;
    padding: 30px 0;

    .text {
        text-transform: uppercase;
    }

    .close-error-modal {
        width: 30%;
        padding: 5px;
        align-self: center;
    }

    &__message {
        padding: 0 30px;
        text-align: left;

        & /deep/ p {
            margin: 5px 0px;

        }

        & /deep/ span {

            white-space: nowrap;
        }
    }
}
</style>
